/*
 * @Description : 准考证相关配置api
 * @Author      : pishengjun
 * @Date        : 2022-07-05 08:51:15
 */

import axios from "@/utils/request";
import { RequestEnum, ServiceGateWay } from "@/utils/enum";
import type { AdmitCardSettingParams, AdmitCardSettingResponse, ExamineeQueryAdmitCard } from "../interfaceModel/admitCardServices";
import { store } from "@/store";

const AdmitCardService = `${ServiceGateWay.AdmitCardService}/api`;
const ArticleService = `${ServiceGateWay.DOCUMENT}`;

export default {
  GET: {
    // 获取准考证设置
    async AdmitCardSettingService(tenantId: string) {
      const examAdmitCardSetting = await axios<AdmitCardSettingResponse>({
        url: `${AdmitCardService}/ExamineeAdmitCardService/AdmitCardSetting`,
        method: RequestEnum.GET,
        options: {
          tenantId: tenantId,
        },
      });
      // store.commit("SET_USER_OPERATION_EXAMMAP", {
      //   tenantId: tenantId,
      //   data: { examAdmitCardSetting },
      // });
      return examAdmitCardSetting;
    },
    // 根据身份证号码查询考生准考证
    getDetailById(idCard: string, tenantId: string) {
      return axios({
        url: `${AdmitCardService}/ExamineeAdmitCardService/ExamineeQueryAdmitCard/${idCard}`,
        method: RequestEnum.GET,
        options: {
          tenantId: tenantId,
        },
      });
    },
    // 根据ID获取文书详情
    getArticleDetailById(id: string, tenantId) {
      return axios({
        url: `${ArticleService}/examinee/article/${id}`,
        method: RequestEnum.GET,
        options: {
          tenantId: tenantId,
        },
      });
    },
    //获取随机码图片 /api/RandomVerificationCodeService/RandomVerificationCode/{randomMark}
    getRandomVerificationCode(randomMark: string, tenantId) {
      return axios({
        url: `${AdmitCardService}/RandomVerificationCodeService/RandomVerificationCode/${randomMark}`,
        method: RequestEnum.GET,
        options: {
          tenantId: tenantId,
        },
      });
    },
    // 获取随机码图片和校验密文（新）
    GetGraph(tenantId) {
      return axios({
        url: `${AdmitCardService}/VerificationCodeService/GetGraph`,
        method: RequestEnum.GET,
        options: {
          tenantId: tenantId,
        },
      });
    },
    // 获取随机码图片和校验密文
    getRandomVerificationCodeMd5(randomMark: string, tenantId) {
      return axios({
        url: `${AdmitCardService}/RandomVerificationCodeService/RandomVerification/${randomMark}`,
        method: RequestEnum.GET,
        options: {
          tenantId: tenantId,
        },
      });
    },
  },
  POST: {
    // 考生端--查询准考证接口
    async postExamineeQueryAdmitCard(params: AdmitCardSettingParams, tenantId: string) {
      const examineeQueryAdmitCard = await axios<ExamineeQueryAdmitCard>({
        url: `${AdmitCardService}/ExamineeAdmitCardService/ExamineeQueryAdmitCard`,
        method: RequestEnum.POST,
        data: params,
        options: {
          noTransform: true,
          tenantId,
        },
      });
      // store.commit("SET_USER_OPERATION_EXAMMAP", {
      //   tenantId: tenantId,
      //   data: { examineeQueryAdmitCardQueryParms: params },
      // });
      // store.commit("SET_USER_OPERATION_EXAMMAP", {
      //   tenantId: tenantId,
      //   data: { examineeQueryAdmitCard },
      // });
      return examineeQueryAdmitCard;
    },
    // 根据考试id集合获取打印准考证时间
    postExamListInfoByExamIds(data: any) {
      return axios({
        url: `${AdmitCardService}/ExamineeAdmitCardService/ExamListInfo`,
        method: RequestEnum.POST,
        data,
        options: {
          noTransform: true,
        },
      });
    },
    // 验证滑动
    verificationSlide(data) {
      return axios<boolean>({
        url: `${AdmitCardService}/VerificationCodeService/VerificationSlide`,
        method: RequestEnum.POST,
        data,
        options: {
          noTransform: true,
        },
      });
    }
  },
  PATCH: {},
};
